import { ErrorData, isDomainError } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

/**
 * Domain errors the server answers with that carry a message of their own. Anything
 * listed here is shown in German; anything else falls back to the server's wording,
 * which is still far more use than a general "check the form".
 */
const messageIdByTitle: Record<string, string> = {
    REGION_COUNTRY_MISMATCH: 'app.error.regionCountryMismatch',
};

/**
 * Turns a rejected save into something the user can act on. Without this a rejection
 * the form cannot pin on a single field ends up as a general hint to check the form —
 * and whoever reads it has no field to check, because none is marked.
 */
export const serverErrorNotification = (error?: ErrorData): PoolNotification => {
    if (!isDomainError(error)) {
        return PoolNotification.error('app.snackbar.error');
    }

    const messageId = messageIdByTitle[error.title];

    return messageId
        ? PoolNotification.error(messageId)
        : PoolNotification.error('app.snackbar.saveFailedWithReason', { reason: error.message });
};
